import React from 'react'
import { useTheme } from '@/context/ThemeContext'

const MemberListHeader: React.FC = () => {
  const { currentTheme: t } = useTheme()
  return (
    <div
      className="flex items-center px-[18px] py-[9px]"
      style={{ background: t.hoverBackground, borderBottom: `1px solid ${t.borderSecondary}` }}
    >
      <span className="flex-1 text-[11px] font-bold uppercase tracking-[0.06em]" style={{ color: t.mutedText }}>Member</span>
      <span className="w-20 text-center text-[11px] font-bold uppercase tracking-[0.06em]" style={{ color: t.mutedText }}>Role</span>
      <span className="hidden md:block w-[150px] text-right text-[11px] font-bold uppercase tracking-[0.06em]" style={{ color: t.mutedText }}>Credits</span>
      <span className="hidden sm:block w-[88px] text-right text-[11px] font-bold uppercase tracking-[0.06em]" style={{ color: t.mutedText }}>Joined</span>
      <span className="w-8" />
    </div>
  )
}

export default React.memo(MemberListHeader)
